import { IconProps } from "./types";
import React from "react";

export const MagnifyingGlassIcon = ({
  className,
  fill = "currentColor",
  width = 11,
  height = 12,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 11 12"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M7.86671 7.54672H7.36935L7.19369 7.3619C7.83858 6.53546 8.18678 5.51212 8.18127 4.45947C8.2224 3.31959 7.81447 2.20979 7.04703 1.3737C6.2796 0.537607 5.21536 0.0435541 4.08797 0C2.96202 0.0456841 1.89987 0.540665 1.13418 1.37652C0.36849 2.21238 -0.0383241 3.32097 0.00284644 4.45947C-0.0383241 5.59798 0.36849 6.70657 1.13418 7.54243C1.89987 8.37828 2.96202 8.87326 4.08797 8.91895C5.0778 8.91419 6.02884 8.52922 6.74841 7.84202L6.91794 8.03407V8.57615L10.0625 12L11 10.9778L7.86671 7.54672ZM4.08797 7.54672C3.3078 7.51662 2.57139 7.17448 2.04069 6.59553C1.50999 6.01659 1.22846 5.24825 1.258 4.45947C1.22846 3.6707 1.50999 2.90236 2.04069 2.32341C2.57139 1.74447 3.3078 1.40232 4.08797 1.37223C4.86815 1.40232 5.60455 1.74447 6.13525 2.32341C6.66595 2.90236 6.94748 3.6707 6.91794 4.45947C6.94748 5.24825 6.66595 6.01659 6.13525 6.59553C5.60455 7.17448 4.86815 7.51662 4.08797 7.54672V7.54672Z"
      fill={fill}
    />
  </svg>
);
